<template>
  <div>
    <Table :columns="columns" :data="tableData" :size="size" :span-method="handleSpan" border>
      <template slot="artificialResult" slot-scope="{row}">
        <template v-if="row.questionType == 'SCORE'">
          <InputNumber
            :disabled="type=='view'"
            :key="row.id+'IN'"
            :max="row.scoreLimit"
            :min="0"
            @on-change="(val) => {changeValue(row, val)}"
            placeholder="请输入得分"
            style="width: 100%"
            v-model="tableData[row._index].artificialResult"
          ></InputNumber>
        </template>
        <template v-else>
          <i-switch
            :disabled="type=='view'"
            :key="row.id+'IS'"
            @on-change="(val) => {changeValue(row, val)}"
            trueColor="#ff4949"
            v-model="tableData[row._index].artificialResult"
          ></i-switch>
        </template>
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  name: 'qcStandard',
  props: {
    size: {
      required: false,
      default: 'default',
    },
    standard: {
      required: true
    },
    aiResult: {
      required: false,
      default: function () {
        return {}
      }
    },
    artificialResult: {
      required: false,
      default: function () {
        return {}
      }
    },
    showAI: {
      required: false,
      default: false
    },
    showSrtificial: {
      required: false,
      default: false
    },
    type: {
      required: false,
      default: 'view'
    }
  },
  data () {
    return {
      tableData: {},
      tableDeep: 0,
      minorNameRowSpanMap: {},
      majorRowSpanMap: {},
      scores: {},
    }
  },
  computed: {
    columns: function () {
      let _this = this
      let children = [
        {
          title: "内容",
          align: "left",
          key: "detail",
          type: 'html',
          tooltip: true,
          minWidth: 300,
        }, {
          title: "备注",
          align: "left",
          key: "remark",
          tooltip: true,
          minWidth: 120,
        }, {
          title: "分值",
          align: "center",
          key: "scoreLimit",
          tooltip: true,
          minWidth: 90,
          render: (h, params) => {
            return h('div', params.row.questionType == 'SCORE' ? params.row.scoreLimit : '--')
          }
        }
      ]

      let base = [{
        title: "大类",
        align: "center",
        key: "majorName",
        tooltip: true,
        minWidth: 140
      }, {
        title: "分项",
        align: "center",
        key: "minorName",
        tooltip: true,
        minWidth: 140,
      }
      ]
      base.push({
        title: "子项",
        align: "center",
        children: children
      })
      // if (this.type != 'view') {
      // if (this.artificialResult && Object.keys(this.artificialResult).length > 0) {
      if (this.showSrtificial && this.showAI) {
        base.push({
          title: "得分",
          align: 'center',
          fixed: 'right',
          children: [
            {
              title: "人工质检",
              align: "center",
              key: "artificialResult",
              fixed: 'right',
              tooltip: true,
              width: 120,
              render: (h, params) => {
                if (_this.artificialResult && Object.keys(_this.artificialResult).length > 0) {
                  return h('div', params.row.questionType == 'SCORE' ? params.row.artificialResult : (params.row.artificialResult ? '是' : '否'))
                } else {
                  return h('div', '--')
                }
              }
            }, {
              title: '智能质检',
              align: "center",
              key: "aiResult",
              tooltip: true,
              fixed: 'right',
              width: 120,
              render: (h, params) => {
                if (_this.aiResult && Object.keys(_this.aiResult).length > 0) {
                  return h('div', params.row.questionType == 'SCORE' ? params.row.aiResult : (params.row.aiResult ? '是' : '否'))
                } else {
                  return h('div', '--')
                }
              }
            }
          ]
        })
      } else {
        if (this.showSrtificial) {
          if (this.type == 'view') {
            base.push({
              title: "得分",
              align: "center",
              key: "artificialResult",
              fixed: 'right',
              tooltip: true,
              width: 120,
              render: (h, params) => {
                if (_this.artificialResult && Object.keys(_this.artificialResult).length > 0) {
                  return h('div', params.row.questionType == 'SCORE' ? params.row.artificialResult : (params.row.artificialResult ? '是' : '否'))
                } else {
                  return h('div', '--')
                }
              }
            })
          } else {
            base.push({
              title: "得分",
              align: "center",
              key: "artificialResult",
              fixed: 'right',
              tooltip: true,
              width: 120,
              slot: 'artificialResult',
            })
          }
        }

        // }

        // if (this.aiResult && Object.keys(this.aiResult).length > 0) {
        if (this.showAI) {
          base.push({
            title: "得分",
            align: "center",
            key: "aiResult",
            fixed: 'right',
            tooltip: true,
            width: 120,
            render: (h, params) => {
              console.log('_this.aiResult', _this.aiResult)
              if (_this.aiResult && Object.keys(_this.aiResult).length > 0) {
                return h('div', params.row.questionType == 'SCORE' ? params.row.aiResult : (params.row.aiResult ? '是' : '否'))
              } else {
                return h('div', '--')
              }
            }
          })
        }

        // }
        // }
      }



      return base
    },
  },
  watch: {
    standard: {
      immediate: true,
      deep: true,
      handler: function (val) {
        this.splitTableData()
      }
    }
  },
  methods: {
    changeValue: function (row, val) {
      this.$emit('change', val)
    },
    handleSpan ({ row, column, rowIndex, columnIndex }) {
      // 大类/分项是多行
      let rowspan = 1
      let needS = row['rowSpanS-' + columnIndex]
      if (columnIndex < 2 && !column.fixed) {
        if (needS) {
          if (columnIndex == 0) {
            rowspan = this.majorRowSpanMap[row.majorName]
          } else if (columnIndex == 1) {
            rowspan = this.minorNameRowSpanMap[row.majorName + '-' + row.minorName]
          }
        } else {
          rowspan = 0
        }
      }
      return {
        rowspan: rowspan,
        colspan: 1
      }
    },
    splitTableData: function () {
      this.tableDeep = 0
      let tableDataBack = []
      this.majorRowSpanMap = {}
      this.minorNameRowSpanMap = {}
      let config = this.standard.config || []
      for (let index = 0; index < config.length; index++) {
        this.handChildren(config[index], tableDataBack, 0)
      }
      tableDataBack.forEach(item => {
        let countMajor = this.majorRowSpanMap[item.majorName] || 0
        this.majorRowSpanMap[item.majorName] = countMajor + 1
        let countMinor = this.minorNameRowSpanMap[item.majorName + '-' + item.minorName] || 0
        this.minorNameRowSpanMap[item.majorName + '-' + item.minorName] = countMinor + 1
      })
      this.tableData = tableDataBack || []
    },
    /**
     * 
     */
    handChildren (item, tableDataBack, level) {
      this.tableDeep = level
      let children = item.children || []
      if (children.length > 0) {
        for (let index = 0; index < children.length; index++) {
          let child = children[index]
          if (index == 0) {
            child['rowSpanS-' + level] = true
          } else {
            child['rowSpanS-' + level] = false
          }

          for (let index = 0; index < level; index++) {
            child['rowSpanS-' + index] = item['rowSpanS-' + index]
          }
          this.handChildren(child, tableDataBack, level + 1)
        }
      } else {
        // 底层
        let copyData = Object.assign({}, item)
        if (item.questionType == 'SCORE') {
          // item.result = this.result[item.id] || 0
          this.$set(copyData, 'artificialResult', this.artificialResult[item.id] || 0)
          this.$set(copyData, 'aiResult', this.aiResult[item.id] || 0)

        } else {
          // item.result = this.result[item.id] || false
          this.$set(copyData, 'artificialResult', this.artificialResult[item.id] || false)
          this.$set(copyData, 'aiResult', this.aiResult[item.id] || false)
        }
        tableDataBack.push(copyData)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.qcStandardTable {
  table-layout: auto;
  border-collapse: collapse;
  width: 100%;
}
</style>